var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5918 8.71921L10.6753 14.7428C9.97173 15.4591 8.83106 15.4591 8.12752 14.7428C7.4225 14.0251 7.42419 12.8608 8.13129 12.1451L12.7194 7.50157L13.8716 6.32849C15.2736 4.90117 17.5466 4.90117 18.9485 6.32849C20.3505 7.75581 20.3505 10.07 18.9485 11.4973L17.8136 12.6527L13.5124 17.0318C11.2874 19.3914 7.91609 19.7505 5.55892 17.4466C3.23061 15.171 3.62525 11.7593 5.97941 9.36252L10.2637 5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip);
export default __webpack_public_path__ + "static/media/icon-clip.e49c5b298e80cd839d386d614f4b1cd7.svg";
export { ForwardRef as ReactComponent };